import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(() => ({
  snackbar: {
    maxWidth: '900px',
  },
}));

export default useStyles;
